(function (module) {
    "use strict";
    module.service('correctionAboutFactsService', [function(this: $TSFixMe) {
        var service = this;

        function correction(data: $TSFixMe, correctionObj: $TSFixMe) {
            if (correctionObj.absoluteValue) {
                return correctionObj.absoluteValue;
            }

            if (correctionObj.impactType === 'absolute') {
                return parseFloat(data) + parseFloat(correctionObj.impact) * parseInt(correctionObj.direction);
            } else if (correctionObj.impactType === 'explicit') {
                return parseFloat(correctionObj.impact);
            } else {
                return parseFloat(data) + (parseFloat(data) * parseInt(correctionObj.direction) * parseFloat(correctionObj.risk) * parseFloat(correctionObj.impact) / 10000);
            }
        }


        service.correctionExFactoryPercent = (correctValue: $TSFixMe, baseValue: $TSFixMe) => {
            let result = (parseFloat(correctValue) * 100 / parseFloat(baseValue)) - 100;
            return result;
        };

        service.correctionExFactoryValue = (correctPercent: $TSFixMe, baseValue: $TSFixMe) => {
            return correction(
                baseValue, {
                    direction: 1,
                    risk: 100,
                    impact: correctPercent
                });
        };

        service.reclaculate = (input: $TSFixMe, parameters: $TSFixMe, correctionsArray: $TSFixMe, freezedMonths = 0) => {

            removedFreezedMonths(parameters, correctionsArray, freezedMonths);

            if (!Array.isArray(correctionsArray) || correctionsArray.length == 0)
                return input;

            
            var month = moment.utc(parameters.forecastStartDate);
            var result = [];

            var j = 0;
            for (let i = 0; i < input.length; i++) {

                var correctedValue = input[i];
                if (j < correctionsArray.length) {
                    
                    if (month.isBetween(moment.utc(correctionsArray[j].startDate), moment.utc(correctionsArray[j].endDate), 'month', '[]')) {
                        correctedValue = correction(input[i], correctionsArray[j]);
                    }

                    if (month.isSameOrAfter(correctionsArray[j].endDate)) {
                        ++j;
                    }
                }

                result[i] = correctedValue;
                month = month.add(1, 'months');
            }
            return result;
        }

        function removeOrUpdate(correctionsArray: $TSFixMe, correction: $TSFixMe, operation: $TSFixMe) {
            
            var correctionStartDate = moment.utc(correction.startDate);

            
            var correctionChangeStartDateIndex = _.findIndex(correctionsArray, (c: $TSFixMe) => correctionStartDate.isBetween(
                
                moment.utc(c.startDate), moment.utc(c.endDate), 'month', '(]'));
            var correctionStartDateEquals;

            var insertIndex = -1;
            //zawiera się w zmieniany przedziale, ktory ma miec zmienioną datę końca,
            // rozpocznij usuwanie badz dodawanie od kolejnego, zmniejsz obecny przedzial
            if (correctionChangeStartDateIndex >= 0) {
                insertIndex = correctionChangeStartDateIndex + 1;
            }
            //jest rowny poczatkowy przedzialu, rozpocznij usuwanie badz dodawanie od obencego
            else if (
                (correctionStartDateEquals =
                    
                    _.findIndex(correctionsArray, (c: $TSFixMe) => correctionStartDate.isSame(moment.utc(c.startDate), 'month'))) >=
                0) {
                insertIndex = correctionStartDateEquals;
            }
            //nie ma przedzialu, rozpocznij dodawania usuwanie od pierwszego, po ostatnim miejszym przedziale            
            else {
                
                insertIndex = _.findLastIndex(correctionsArray, (c: $TSFixMe) => correctionStartDate.isSameOrAfter(moment.utc(c.startDate), 'month')) + 1;
            }

            
            var correctionEndDate = moment.utc(correction.endDate);
            
            var correctionChangeDateEndIndex = _.findIndex(correctionsArray, (c: $TSFixMe) => correctionEndDate.isBetween(
                
                moment.utc(c.startDate), moment.utc(c.endDate), 'month', '[)'));

            var lastInsertIndex, correctionEndDateEquals;

            //zawiera się w zmieniany przedziale, ktory ma miec zmienioną datę początku,
            // zaznacz przedział do usunięcia jako poprzeni
            if (correctionChangeDateEndIndex >= 0) {
                lastInsertIndex = correctionChangeDateEndIndex - 1;
            }
            //data końca korekty jest równa końcowi przedziału,
            // zanzacz znaleziony jako do usunięcia
            
            else if ((correctionEndDateEquals = _.findLastIndex(correctionsArray, (c: $TSFixMe) => correctionEndDate.isSame(moment.utc(c.endDate), 'month'))) >=
                0) {
                lastInsertIndex = correctionEndDateEquals;
            }
            //nie trafiono w przedział, znajdz ostatni, który zawiera się w zmianie            
            else {
                
                lastInsertIndex = _.findLastIndex(correctionsArray, (c: $TSFixMe) => correctionEndDate.isAfter(moment.utc(c.endDate), 'month'));
            }

            //jeden przedział jest do zmiany - trzeba go podzielić
            if (correctionChangeStartDateIndex == correctionChangeDateEndIndex && correctionChangeStartDateIndex >= 0) {
                var firstCorrection = correctionsArray[correctionChangeStartDateIndex];

                var lastCorrection = angular.copy(firstCorrection);
                
                firstCorrection.endDate = moment.utc(correction.startDate).add(-1, 'months').toDate();
                
                lastCorrection.startDate = moment.utc(correction.endDate).add(1, 'months').toDate();

                correctionsArray.splice(correctionChangeStartDateIndex + 1, 0, lastCorrection);
                insertIndex = correctionChangeStartDateIndex + 1;
                lastInsertIndex = insertIndex - 1;

            } else {
                if (correctionChangeStartDateIndex >= 0) {
                    var firstCorrection = correctionsArray[correctionChangeStartDateIndex];
                    
                    firstCorrection.endDate = moment.utc(correction.startDate).add(-1, 'months').toDate();
                }

                if (correctionChangeDateEndIndex >= 0) {
                    var lastCorrection = correctionsArray[correctionChangeDateEndIndex];
                    
                    lastCorrection.startDate = moment.utc(correction.endDate).add(1, 'months').toDate();
                }
            }


            if (operation == 'remove') {
                correctionsArray.splice(insertIndex, lastInsertIndex - insertIndex + 1);
            } else {
                correctionsArray.splice(insertIndex, lastInsertIndex - insertIndex + 1, {
                    desc: correction.desc,
                    name: correction.name,
                    startDate: correction.startDate,
                    endDate: correction.endDate,
                    risk: correction.risk,
                    impact: correction.impact,
                    direction: correction.direction,
                    impactType: correction.impactType,
                    absoluteValue: correction.absoluteValue
                });
            }
        }

        function removedFreezedMonths(parameters: $TSFixMe, correctionsArray: $TSFixMe, freezedMonths: $TSFixMe) {
            if (freezedMonths == 0) {
                return;
            }
            
            var endDate = moment.utc(parameters.forecastStartDate).add(freezedMonths - 1, 'months').toDate();
            removeOrUpdate(correctionsArray, {
                startDate: parameters.forecastStartDate,
                endDate
            }, 'remove');
        }

        service.addOrUpdateCorrection = (input: $TSFixMe, parameters: $TSFixMe, correctionsArray: $TSFixMe, correction: $TSFixMe) => {
            // @ts-expect-error ts-migrate(2554) FIXME: Expected 3 arguments, but got 2.
            removeOrUpdate(correctionsArray, correction);
            return service.reclaculate(input, parameters, correctionsArray);
        }

        service.removeCorrection = (input: $TSFixMe, parameters: $TSFixMe, correctionsArray: $TSFixMe, startDate: $TSFixMe, endDate: $TSFixMe) => {
            removeOrUpdate(correctionsArray, {
                startDate: startDate,
                endDate: endDate
            }, 'remove');
            return service.reclaculate(input, parameters, correctionsArray);
        }

    }]);


})(angular.module('topline.services'));